/* eslint-disable @typescript-eslint/camelcase */
export var Providers = {
    // ARG
    AMEX_REGULAR: 'amex_regular',
    AMEX: 'amex_regular',
    CABAL_NEW: 'cabal_regular',
    CABAL_REGULAR: 'cabal_regular',
    CABAL: 'cabal_regular',
    FIRST_DATA_NEW: 'first_data_regular',
    FIRST_DATA_OLD: 'first_data_regular',
    FIRST_DATA_REGULAR: 'first_data_regular',
    FIRST_DATA: 'first_data_regular',
    MERCADOPAGO: 'mercadopago',
    NARANJA_REGULAR: 'naranja_regular',
    NARANJA: 'naranja_regular',
    PRISMA: 'prisma',
    VISA: 'prisma',
    // UY
    CREDIMATIC: 'creditel',
    CREDITEL: 'creditel',
    OCA: 'oca',
    VISANET: 'visanet',
    // ?
    UNKNOWN: 'unknown'
};
export var INFOLINKS = {
    argentina: {
        prisma: 'https://establecimientos.prismamediosdepago.com/establecimientos/login?vhe',
        first_data_regular: 'https://www.firstdata.com.ar/index.html',
        cabal_regular: 'https://smpc.cabal.coop/Cabaldiaseguridad/Pages/Login.aspx',
        amex_regular: 'https://www.americanexpress.com/argentina/merchant/home/merchant_login.shtml',
        naranja_regular: 'https://comercios.naranja.com/',
        mercadopago: 'https://www.mercadopago.com.ar/'
    },
    uruguay: {
        visanet: 'https://www.vnet.com.uy/deposito/Login/Login.aspx?ReturnUrl=%2fdeposito%2fDefault.aspx',
        oca: 'https://comerciosweb.oca.com.uy/index.aspx',
        creditel: 'https://comercios.creditel.com.uy',
        amex_regular: 'https://www1.scotiabank.com.uy/scotiaenlinea/login?url=%2Fscotiaenlinea%2Fdesktop',
        first_data_regular: 'https://www.firstdata.com.uy'
    }
};
export var PROVIDERS_TO_SHOW = {
    argentina: [
        Providers.AMEX,
        Providers.CABAL,
        Providers.FIRST_DATA,
        Providers.MERCADOPAGO,
        Providers.NARANJA_REGULAR,
        Providers.PRISMA
    ],
    uruguay: [
        Providers.AMEX_REGULAR,
        Providers.CREDITEL,
        Providers.FIRST_DATA_REGULAR,
        Providers.OCA,
        Providers.VISANET
    ]
};
export var OTHER_LOGIN_PROVIDERS = {
    argentina: [Providers.CABAL],
    uruguay: [Providers.AMEX_REGULAR, Providers.OCA, Providers.VISANET]
};
